import React from 'react';

interface PortalPageHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  icon?: React.ReactNode;
  align?: 'start' | 'center';
  children?: React.ReactNode;
}

/** Shared page intro matching home section typography. */
const PortalPageHeader: React.FC<PortalPageHeaderProps> = ({
  eyebrow,
  title,
  description,
  icon,
  align = 'start',
  children,
}) => {
  const centered = align === 'center';

  return (
    <div className={`mb-5 sm:mb-7 ${centered ? 'text-center' : 'text-start'}`}>
      <div
        className={`mb-3 flex items-center gap-2.5 ${centered ? 'justify-center' : 'justify-start'}`}
      >
        <span className="inline-block h-5 w-1 shrink-0 rounded-full bg-[rgb(135_179_215)]" aria-hidden />
        <p className="inline-flex items-center gap-2 text-sm font-semibold text-primary-dark">
          {icon}
          {eyebrow}
        </p>
      </div>
      <h1 className="font-display text-[clamp(1.5rem,1.4vw+1rem,2.15rem)] font-extrabold leading-snug text-primary-dark">
        {title}
      </h1>
      {description && (
        <p
          className={`mt-2 text-sm leading-relaxed text-slate-600 sm:text-base sm:leading-7 ${
            centered ? 'mx-auto max-w-xl' : 'max-w-2xl'
          }`}
        >
          {description}
        </p>
      )}
      {children}
    </div>
  );
};

export default PortalPageHeader;
